module.exports = __webpack_public_path__ + "static/media/portfolio1 (11).8b79294e.jpeg";